export const SOURCE_ID_SPLITTER = '__messenger_source_id_splitter__';
